import { AI_CENTER_TABS, type AiCenterTabKey } from "./ai-center-tabs.ts"

// Whether a tool is released. "Coming soon" only closes the door: the tool's
// screens, services and data stay in place, and releasing it is flipping its
// `status` in AI_CENTER_TABS — the one switch the tab bar, the tool's routes and
// its entry points elsewhere in the app all read.
export const isAiToolAvailable = (key: AiCenterTabKey): boolean =>
  AI_CENTER_TABS.find((tab) => tab.key === key)?.status === "live"
